import { CONSTANT, FILING_STATUS } from '../../../constant/constant';
import { ENDPOINTS } from '../../../constant/endpoints';
import {
    generalHttpGetRequest,
    generalHttpPostRequest,
    generalHttpPutRequest
} from '../../../helper/request-helper';

const fetchFilingsUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.filing.fetchFilings;
const fetchPendingFilingsUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.filing.fetchPendingFilings;
const fetchCancelledFilingsUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.filing.fetchCancelledFilings;
const fetchRecentExemptedFilingsUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.filing.fetchRecentExemptedFilings;
const fetchPendingAmendmentsUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.filing.fetchPendingAmendments;
const fetchFilingsByEffectiveDateUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.filing.fetchFilingsByEffectiveDate;
const fetchFilingsReadyForRenewalUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.filing.fetchFilingsReadyForRenewal;
const fetchTerminatedFilingsUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.filing.fetchTerminatedFilings;
const fetchEverActiveFilingsUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.filing.fetchEverActiveFilings;
const fetchFilingsByFileByDateUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.filing.fetchFilingsByFileByDate;
const updateFilingUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.filing.updateFiling;
const submitNewFilingRequestUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.filing.submitNewFiling;
const filingsAllActiveRequestUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.filing.filingsAllActive;
const submitNewFilingsRequestUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.filing.submitNewFilings;
const fileWithStateUrl = CONSTANT.baseUrl + ENDPOINTS.commonData.fileWithState;
const fetchTrustsStatesUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.trust.fetchTrustStates;
const fetchPortfolioStatesUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.portfolio.fetchPortfolioStates;
const fetchClassStatesUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.classes.fetchClassStates;
const fetchProspectusStatesUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.prospectus.fetchProspectusStates;
const fetchClientDataUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.clientInformation.fetchClientList;
const fetchStateDataUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.state.fetchState;
const changeFilingStatusUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.filing.changeFilingStatus;
const changeFilingListStatusUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.filing.changeFilingListStatus;
const parseElectronicFilingUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.filing.parseElectronicFiling;
const submitNewElectronicFilingUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.filing.submitNewElectronicFiling;
const fetchElectronicFilingsUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.filing.fetchElectronicFilings;

export const actionType = {
    REQUESTED_FILING_DATA: 'REQUESTED_FILING_DATA',
    REJECTED_FILING_DATA: 'REJECTED_FILING_DATA',
    UPDATE_FILING: 'UPDATE_FILING',
    HOLD_FILING: 'HOLD_FILING',
    CANCEL_FILING: 'CANCEL_FILING',
    SET_PENDING_FILING: 'SET_PENDING_FILING',
    APPROVE_FILING: 'APPROVE_FILING',
    DENY_FILING: 'DENY_FILING',
    IN_PROGRESS_FILING: 'IN_PROGRESS_FILING',
    IN_PROGRESS_FILING_LIST: 'IN_PROGRESS_FILING_LIST',
    FETCH_FILING_BY_ID: 'FETCH_FILING_BY_ID',
    FETCH_PENDING_FILINGS: 'FETCH_PENDING_FILINGS',
    FETCH_CANCELLED_FILINGS: 'FETCH_CANCELLED_FILINGS',
    FETCH_RECENT_EXEMPTED_FILINGS: 'FETCH_RECENT_EXEMPTED_FILINGS',
    FETCH_PENDING_AMENDMENTS: 'FETCH_PENDING_AMENDMENTS',
    FETCH_FILINGS_BY_EFFECTIVEDATE: 'FETCH_FILINGS_BY_EFFECTIVEDATE',
    FETCH_FILINGS_READY_FOR_RENEWAL: 'FETCH_FILINGS_READY_FOR_RENEWAL',
    FETCH_TERMINATED_FILINGS: 'FETCH_TERMINATED_FILINGS',
    FETCH_EVER_ACTIVE_FILINGS: 'FETCH_EVER_ACTIVE_FILINGS',
    FETCH_FILINGS_BY_FILEBY_DATE: 'FETCH_FILINGS_BY_FILEBY_DATE',
    FETCH_FILINGS_BY_CLIENT: 'FETCH_FILINGS_BY_CLIENT',
    CLEAR_EFFDATE_SEARCH: 'CLEAR_EFFDATE_SEARCH',
    CLEAR_READY_FOR_RENEVAL_SEARCH: 'CLEAR_READY_FOR_RENEVAL_SEARCH',
    CLEAR_BYCLIENT_SEARCH: 'CLEAR_BYCLIENT_SEARCH',
    CLEAR_TERMINATED_SEARCH: 'CLEAR_TERMINATED_SEARCH',
    CLEAR_EVER_ACTIVE_SEARCH: 'CLEAR_EVER_ACTIVE_SEARCH',
    SUBMIT_NEW_FILING_REQUEST: 'SUBMIT_NEW_FILING_REQUEST',
    SUBMIT_NEW_FILING_LIST_REQUEST: 'SUBMIT_NEW_FILING_LIST_REQUEST',
    FILE_WITH_STATE: 'FILE_WITH_STATE',
    UPDATE_FILING_SELECTED: 'UPDATE_FILING_SELECTED',
    UPDATE_SELECTED_FILING_LIST: 'UPDATE_SELECTED_FILING_LIST',
    UPDATE_SELECTED_STATES_LIST: 'UPDATE_SELECTED_STATES_LIST',
    UPDATE_SECURITY_SELECTED: 'UPDATE_SECURITY_SELECTED',
    UPDATE_STATE_SELECTED: 'UPDATE_STATE_SELECTED',
    UPDATE_EDIT_FILING_PAYLOAD: 'UPDATE_EDIT_FILING_PAYLOAD',
    UPDATE_FILING_INFO_DATA: 'UPDATE_FILING_INFO_DATA',
    UPDATE_NEW_FILING_PAYLOAD: 'UPDATE_NEW_FILING_PAYLOAD',
    UPDATE_FILING_REQUEST_PAYLOAD: 'UPDATE_FILING_REQUEST_PAYLOAD',
    CLEAR_FILINGS_DATA: 'CLEAR_FILINGS_DATA',
    FETCH_PROSPECTUS_STATES: 'FETCH_PROSPECTUS_STATES',
    FETCH_PORTFOLIO_STATES: 'FETCH_PORTFOLIO_STATES',
    FETCH_CLASS_STATES: 'FETCH_CLASS_STATES',
    FETCH_TRUST_STATES: 'FETCH_TRUST_STATES',
    FETCH_CLIENT_DATA: 'FETCH_CLIENT_DATA',
    FETCH_STATE_DATA: 'FETCH_STATE_DATA',
    SET_TO_BILLED_FILING: 'SET_TO_BILLED_FILING',
    SET_TO_BILLED_FILING_LIST: 'SET_TO_BILLED_FILING_LIST',
    SET_TO_PAID_FILING: 'SET_TO_PAID_FILING',
    SET_TO_PAID_FILING_LIST: 'SET_TO_PAID_FILING_LIST',
    SET_TO_HOLD_FOR_PAYMENT_FILING: 'SET_TO_HOLD_FOR_PAYMENT_FILING',
    SET_TO_READY_FOR_RENEWAL_FILING: 'SET_TO_READY_FOR_RENEWAL_FILING',
    TERMINATE_FILING: 'TERMINATE_FILING',
    CHANGE_STATUS_FILING: 'CHANGE_STATUS_FILING',
    CHANGE_STATUS_FILING_LIST: 'CHANGE_STATUS_FILING_LIST',
    UPDATE_FILINGS_ACTIVE_TAB: 'UPDATE_FILINGS_ACTIVE_TAB',
    UPDATE_SEARCH_CLIENT_SELECTED: 'UPDATE_SEARCH_CLIENT_SELECTED',
    PARSE_ELECTRONIC_FILING: 'PARSE_ELECTRONIC_FILING',
    CLEAR_ELECTRONIC_FILING_PARSE: 'CLEAR_ELECTRONIC_FILING_PARSE',
    SUBMIT_NEW_ELECTRONIC_FILING: 'SUBMIT_NEW_ELECTRONIC_FILING',
    FETCH_ELECTRONIC_FILINGS: 'FETCH_ELECTRONIC_FILINGS'
};

export const fetchTrustStates = trustId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_FILING_DATA
        });

        return generalHttpGetRequest(fetchTrustsStatesUrl + trustId)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_TRUST_STATES,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_FILING_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const fetchPortfolioStates = portfolioId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_FILING_DATA
        });

        return generalHttpGetRequest(fetchPortfolioStatesUrl + portfolioId)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_PORTFOLIO_STATES,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_FILING_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const fetchClassStates = classId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_FILING_DATA
        });

        return generalHttpGetRequest(fetchClassStatesUrl + classId)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_CLASS_STATES,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_FILING_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const fetchProspectusStates = prospectusId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_FILING_DATA
        });

        return generalHttpGetRequest(fetchProspectusStatesUrl + prospectusId)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_PROSPECTUS_STATES,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_FILING_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const fetchFilingById = filingId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_FILING_DATA
        });

        return generalHttpGetRequest(fetchFilingsUrl + filingId)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_FILING_BY_ID,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_FILING_DATA,
                    data: error
                });
            });
    };
};

export const fetchPendingFilings = () => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_FILING_DATA
        });

        return generalHttpGetRequest(fetchPendingFilingsUrl)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_PENDING_FILINGS,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_FILING_DATA,
                    data: error
                });
            });
    };
};

export const fetchCancelledFilings = () => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_FILING_DATA
        });

        return generalHttpGetRequest(fetchCancelledFilingsUrl)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_CANCELLED_FILINGS,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_FILING_DATA,
                    data: error
                });
            });
    };
};

export const fetchRecentExemptedFilings = () => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_FILING_DATA
        });

        return generalHttpGetRequest(fetchRecentExemptedFilingsUrl)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_RECENT_EXEMPTED_FILINGS,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_FILING_DATA,
                    data: error
                });
            });
    };
};

export const fetchPendingAmendments = () => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_FILING_DATA
        });

        return generalHttpGetRequest(fetchPendingAmendmentsUrl)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_PENDING_AMENDMENTS,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_FILING_DATA,
                    data: error
                });
            });
    };
};

export const fetchFilingsByEffectiveDate = params => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_FILING_DATA
        });

        return generalHttpGetRequest(
            fetchFilingsByEffectiveDateUrl,
            params,
            true
        )
            .then(response => {
                dispatch({
                    type: actionType.FETCH_FILINGS_BY_EFFECTIVEDATE,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_FILING_DATA,
                    data: error
                });
            });
    };
};

export const fetchFilingsReadyForRenewal = clientId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_FILING_DATA
        });

        return generalHttpGetRequest(
            fetchFilingsReadyForRenewalUrl + clientId,
            null,
            true
        )
            .then(response => {
                dispatch({
                    type: actionType.FETCH_FILINGS_READY_FOR_RENEWAL,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_FILING_DATA,
                    data: error
                });
            });
    };
};

export const fetchTerminatedFilings = clientId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_FILING_DATA
        });

        return generalHttpGetRequest(
            fetchTerminatedFilingsUrl + clientId,
            null,
            true
        )
            .then(response => {
                dispatch({
                    type: actionType.FETCH_TERMINATED_FILINGS,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_FILING_DATA,
                    data: error
                });
            });
    };
};

export const fetchEverActiveFilings = clientId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_FILING_DATA
        });

        return generalHttpGetRequest(
            fetchEverActiveFilingsUrl + clientId,
            null,
            true
        )
            .then(response => {
                dispatch({
                    type: actionType.FETCH_EVER_ACTIVE_FILINGS,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_FILING_DATA,
                    data: error
                });
            });
    };
};

export const fetchFilingsByFileByDate = params => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_FILING_DATA
        });

        return generalHttpGetRequest(fetchFilingsByFileByDateUrl, params, true)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_FILINGS_BY_FILEBY_DATE,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_FILING_DATA,
                    data: error
                });
            });
    };
};

export const fetchClientData = clientId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_FILING_DATA
        });

        return generalHttpGetRequest(fetchClientDataUrl + clientId)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_CLIENT_DATA,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_FILING_DATA,
                    data: error
                });
            });
    };
};

export const fetchStateData = clientId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_FILING_DATA
        });

        return generalHttpGetRequest(fetchStateDataUrl + clientId)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_STATE_DATA,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_FILING_DATA,
                    data: error
                });
            });
    };
};

export const updateFiling = (filingId, payload) => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_FILING_DATA
        });

        return generalHttpPutRequest(updateFilingUrl + filingId, payload)
            .then(response => {
                dispatch({
                    type: actionType.UPDATE_FILING,
                    payload: response.data
                });
                return response;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_FILING_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const fetchActiveFilingsByClientId = clientId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_FILING_DATA
        });

        return generalHttpGetRequest(filingsAllActiveRequestUrl + clientId)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_FILINGS_BY_CLIENT,
                    payload: response.data
                });
                return response;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_FILING_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const submitNewFilingRequest = payload => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_FILING_DATA
        });

        return generalHttpPostRequest(submitNewFilingRequestUrl, payload)
            .then(response => {
                dispatch({
                    type: actionType.SUBMIT_NEW_FILING_REQUEST,
                    payload: response.data
                });
                return response;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_FILING_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const submitNewFilingListRequest = payload => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_FILING_DATA
        });

        return generalHttpPostRequest(submitNewFilingsRequestUrl, payload)
            .then(response => {
                dispatch({
                    type: actionType.SUBMIT_NEW_FILING_LIST_REQUEST,
                    payload: response.data
                });
                return response;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_FILING_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const fileWithState = filingId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_FILING_DATA
        });

        return generalHttpPostRequest(fileWithStateUrl + filingId)
            .then(response => {
                dispatch({
                    type: actionType.FILE_WITH_STATE,
                    payload: response.data
                });
                return response;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_FILING_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const holdFiling = filingId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_FILING_DATA
        });

        return generalHttpPutRequest(
            changeFilingStatusUrl +
                filingId +
                '?filingStatus=' +
                FILING_STATUS.ON_HOLD
        )
            .then(response => {
                dispatch({
                    type: actionType.HOLD_FILING,
                    payload: response.data
                });
                return response;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_FILING_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const changeFilingStatus = (filingId, filingStatus) => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_FILING_DATA
        });

        return generalHttpPutRequest(
            changeFilingStatusUrl + filingId + '?filingStatus=' + filingStatus
        )
            .then(response => {
                dispatch({
                    type: actionType.CHANGE_STATUS_FILING,
                    payload: response.data
                });
                return response;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_FILING_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const cancelFiling = filingId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_FILING_DATA
        });

        return generalHttpPutRequest(
            changeFilingStatusUrl +
                filingId +
                '?filingStatus=' +
                FILING_STATUS.CLIENT_CANCELLED
        )
            .then(response => {
                dispatch({
                    type: actionType.CANCEL_FILING,
                    payload: response.data
                });
                return response;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_FILING_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const setPendingFiling = filingId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_FILING_DATA
        });

        return generalHttpPutRequest(
            changeFilingStatusUrl +
                filingId +
                '?filingStatus=' +
                FILING_STATUS.PENDING
        )
            .then(response => {
                dispatch({
                    type: actionType.SET_PENDING_FILING,
                    payload: response.data
                });
                return response;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_FILING_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const approveFiling = filingId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_FILING_DATA
        });

        return generalHttpPutRequest(
            changeFilingStatusUrl +
                filingId +
                '?filingStatus=' +
                FILING_STATUS.APPROVED
        )
            .then(response => {
                dispatch({
                    type: actionType.APPROVE_FILING,
                    payload: response.data
                });
                return response;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_FILING_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const denyFiling = filingId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_FILING_DATA
        });

        return generalHttpPutRequest(
            changeFilingStatusUrl +
                filingId +
                '?filingStatus=' +
                FILING_STATUS.DENIED
        )
            .then(response => {
                dispatch({
                    type: actionType.DENY_FILING,
                    payload: response.data
                });
                return response;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_FILING_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const inProgressFiling = filingId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_FILING_DATA
        });

        return generalHttpPutRequest(
            changeFilingStatusUrl +
                filingId +
                '?filingStatus=' +
                FILING_STATUS.IN_PROGRESS
        )
            .then(response => {
                dispatch({
                    type: actionType.IN_PROGRESS_FILING,
                    payload: response.data
                });
                return response;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_FILING_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const inProgressFilingList = filingList => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_FILING_DATA
        });

        return generalHttpPutRequest(
            changeFilingListStatusUrl + FILING_STATUS.IN_PROGRESS,
            filingList
        )
            .then(response => {
                dispatch({
                    type: actionType.IN_PROGRESS_FILING_LIST,
                    payload: response.data
                });
                return response;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_FILING_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const changeStatusFilingList = (filingStatus, filingList) => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_FILING_DATA
        });

        return generalHttpPutRequest(
            changeFilingListStatusUrl + filingStatus,
            filingList
        )
            .then(response => {
                dispatch({
                    type: actionType.CHANGE_STATUS_FILING_LIST,
                    payload: response.data
                });
                return response;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_FILING_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const setToHoldForPaymentFiling = filingId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_FILING_DATA
        });

        return generalHttpPutRequest(
            changeFilingStatusUrl +
                filingId +
                '?filingStatus=' +
                FILING_STATUS.HOLD_FOR_PAYMENT
        )
            .then(response => {
                dispatch({
                    type: actionType.SET_TO_HOLD_FOR_PAYMENT_FILING,
                    payload: response.data
                });
                return response;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_FILING_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const setToReadyForRenewalFiling = filingId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_FILING_DATA
        });

        return generalHttpPutRequest(
            changeFilingStatusUrl +
                filingId +
                '?filingStatus=' +
                FILING_STATUS.READY_FOR_RENEWAL
        )
            .then(response => {
                dispatch({
                    type: actionType.SET_TO_READY_FOR_RENEWAL_FILING,
                    payload: response.data
                });
                return response;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_FILING_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const terminateFiling = filingId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_FILING_DATA
        });

        return generalHttpPutRequest(
            changeFilingStatusUrl +
                filingId +
                '?filingStatus=' +
                FILING_STATUS.TERMINATED
        )
            .then(response => {
                dispatch({
                    type: actionType.TERMINATE_FILING,
                    payload: response.data
                });
                return response;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_FILING_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const exemptFiling = filingId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_FILING_DATA
        });

        return generalHttpPutRequest(
            changeFilingStatusUrl +
                filingId +
                '?filingStatus=' +
                FILING_STATUS.EXEMPTION_APPROVED
        )
            .then(response => {
                dispatch({
                    type: actionType.CHANGE_STATUS_FILING,
                    payload: response.data
                });
                return response;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_FILING_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const clearFilingsData = () => {
    return dispatch => {
        return dispatch({
            type: actionType.CLEAR_FILINGS_DATA
        });
    };
};

export const updateFilingInfoData = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.UPDATE_FILING_INFO_DATA,
            payload: selected
        });
    };
};

export const updateEditFilingPayload = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.UPDATE_EDIT_FILING_PAYLOAD,
            payload: selected
        });
    };
};

export const updateNewFilingPayload = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.UPDATE_NEW_FILING_PAYLOAD,
            payload: selected
        });
    };
};

export const updateFilingRequestPayload = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.UPDATE_FILING_REQUEST_PAYLOAD,
            payload: selected
        });
    };
};

export const updateStateSelected = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.UPDATE_STATE_SELECTED,
            payload: selected
        });
    };
};

export const updateSecuritySelected = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.UPDATE_SECURITY_SELECTED,
            payload: selected
        });
    };
};

export const updateFilingSelected = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.UPDATE_FILING_SELECTED,
            payload: selected
        });
    };
};

export const updateSelectedFilingList = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.UPDATE_SELECTED_FILING_LIST,
            payload: selected
        });
    };
};

export const updateSelectedStatesList = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.UPDATE_SELECTED_STATES_LIST,
            payload: selected
        });
    };
};

export const clearFilingsByEffectiveDateSearch = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.CLEAR_EFFDATE_SEARCH,
            payload: selected
        });
    };
};

export const clearFilingsReadyForRenewalTab = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.CLEAR_READY_FOR_RENEVAL_SEARCH,
            payload: selected
        });
    };
};

export const clearFilingsByClientTab = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.CLEAR_BYCLIENT_SEARCH,
            payload: selected
        });
    };
};

export const clearTerminatedFilingsTab = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.CLEAR_TERMINATED_SEARCH,
            payload: selected
        });
    };
};

export const clearEverActiveFilingsTab = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.CLEAR_EVER_ACTIVE_SEARCH,
            payload: selected
        });
    };
};

export const updateFilingsActiveTabKey = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.UPDATE_FILINGS_ACTIVE_TAB,
            payload: selected
        });
    };
};

export const updateClientSelected = clientVar => {
    return dispatch => {
        return dispatch({
            type: actionType.UPDATE_SEARCH_CLIENT_SELECTED,
            payload: clientVar
        });
    };
};

export const parseElectronicFiling = payload => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_FILING_DATA
        });

        return generalHttpPostRequest(parseElectronicFilingUrl, payload)
            .then(response => {
                dispatch({
                    type: actionType.PARSE_ELECTRONIC_FILING,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_FILING_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const clearElectronicFilingParse = () => {
    return dispatch => {
        return dispatch({
            type: actionType.CLEAR_ELECTRONIC_FILING_PARSE
        });
    };
};

export const submitNewElectronicFiling = payload => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_FILING_DATA
        });

        return generalHttpPostRequest(submitNewElectronicFilingUrl, payload)
            .then(response => {
                dispatch({
                    type: actionType.SUBMIT_NEW_ELECTRONIC_FILING,
                    payload: response.data
                });
                return response;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_FILING_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const fetchElectronicFilings = params => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_FILING_DATA
        });

        return generalHttpGetRequest(fetchElectronicFilingsUrl, params)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_ELECTRONIC_FILINGS,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_FILING_DATA,
                    data: error
                });
                return error;
            });
    };
};



// WEBPACK FOOTER //
// ./src/services/redux/employee/filing/actions.js